export default __webpack_public_path__ + "static/media/icon.sleeping bags.1c68b3ca.svg";